// 这个方法应该用的比较少，或者就没用了 用myUtils中的方法取代
/* 时间格式化 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  if (date === null || date === undefined) {
    return ''
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  /*
      replace() 第二个参数为匿名函数时：
        (a, b, c, d) => {}
        a: 被匹配字段
        b: 替换后字段(括号内匹配字段)
        c: 匹配位置
        d: 被匹配原字符串
        例： {y}-----y-------0--------- {y}-{m}-{d} {h}:{i}:{s}
    */
  // eslint-disable-next-line camelcase
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  // eslint-disable-next-line camelcase
  return time_str
}
